<footer class="uk-flex uk-flex-center">
    <div class="copyright">
        <a routerLink="/" fragment="top" title="トップ">@2021 SHIRAKAMI LIFE DESIGN</a>
    </div>
    <div class="policy">
        <a routerLink="/policy" fragment="top" title="プライバシーポリシー">プライバシーポリシー</a>
    </div>
</footer>